import { PusatResolusiV2Component } from "@/app/infrastructures/dependencies/modules/PusatResolusiV2Component";
import {
  Action,
  Module,
  Mutation,
  VuexModule,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { PusatResolusiV2Presenter } from "../presenters/PusatResolusiV2Presenter";
import {
  CheckTicketPusatResolusiRequest,
  FinishIssuePusatResolusiV2Request,
  ListTicketPusatResolusiRequest,
  SendChatPusatResolusiRequest,
  SubmitNotePusatResolusiRequest,
  GetConversationRequest,
  ListSTTPusatResolusi,
  TicketCounterPusatResolusiRequest,
  SubmitFeedbackApiRequest,
  FollowTicketApiRequest,
  AddTemplatePusatResolusiRequest,
  GetTicketActionRequest,
  DownloadLaporanRequest,
  CheckCategoryPusatResolusiRequest,
  ReopenPusatResolusiV2Request
} from "@/data/payload/api/PusatResolusiV2ApiRequest";
import {
  BulkDownload,
  MentionsData,
  PusatResolusiFilter,
  PusatResolusiFilterTemp,
  PusatResolusiSTT
} from "@/domain/entities/PusatResolusiV2";
import { ApiRequestList, StateCondition } from "@/domain/entities/MainApp";
import { MainAppController } from "./MainAppController";
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";

PusatResolusiV2Component.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "pusat-resolusi-v2"
})
class PusatResolusiV2Store extends VuexModule {
  lastSttOrShipmentNoList: PusatResolusiSTT[] = [];
  chatMessage = "";
  mentionSelected: MentionsData[] = [];
  uploadedFiles: any[] = [];
  chatMessageFinish = "";
  mentionSelectedFinish: MentionsData[] = [];
  uploadedFilesFinish: any[] = [];
  filter: PusatResolusiFilter = new PusatResolusiFilter();
  tempFilterTicket: PusatResolusiFilterTemp = new PusatResolusiFilterTemp();
  tabActive = "";
  chatMessageReopen = "";
  loadingAction = false;

  @Mutation
  public resetFilter() {
    this.filter = new PusatResolusiFilter();
    this.tempFilterTicket = new PusatResolusiFilterTemp();
    this.tabActive = "";
  }

  @Mutation
  public setChatMessage(val: string) {
    this.chatMessage = val;
  }

  @Mutation
  public setMentionSelected(val: any) {
    this.mentionSelected = val;
  }

  @Mutation
  public setUploadedFiles(val: any) {
    this.uploadedFiles = val;
  }

  @Mutation
  public setChatMessageFinish(val: string) {
    this.chatMessageFinish = val;
  }

  @Mutation
  public setChatMessageReopen(val: string) {
    this.chatMessageReopen = val;
  }

  @Mutation
  public setMentionSelectedFinish(val: any) {
    this.mentionSelectedFinish = val;
  }

  @Mutation
  public setMentionSelectedReopen(val: any) {
    this.mentionSelectedFinish = val;
  }

  @Mutation
  public setUploadedFilesFinish(val: any) {
    this.uploadedFilesFinish = val;
  }

  @Mutation
  public setUploadedFilesReopen(val: any) {
    this.uploadedFilesFinish = val;
  }

  @Mutation
  public setLastSttOrShipmentNoList(data: PusatResolusiSTT[]) {
    this.lastSttOrShipmentNoList = data;
  }

  @Mutation
  public setFilter(filter: PusatResolusiFilter) {
    this.filter = filter;
  }

  @Mutation
  public setFilterTemp(filter: PusatResolusiFilterTemp) {
    this.tempFilterTicket = filter;
  }

  @Mutation
  public setActiveTab(tab: string) {
    this.tabActive = tab;
  }

  @Mutation
  public setLoadingAction(val: boolean) {
    this.loadingAction = val;
  }

  @Action
  public checkTicket(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkTicket(params);
  }

  @Action
  public checkCategory(payload: CheckCategoryPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkCategory(payload);
  }

  @Action
  public getListCategory(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getListCategory(params);
  }

  @Action
  public submitFeedback(params: {
    id: number;
    payload: SubmitFeedbackApiRequest;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.submitFeedback(params.id, params.payload);
  }

  @Action
  public getSTTList(params: { params: ListSTTPusatResolusi }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getSTTList(params.params);
  }

  @Action
  public checkIssue(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkIssue(params);
  }

  @Action
  public checkIssueV2(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkIssueV2(params);
  }

  @Action
  public followTicket(payload: FollowTicketApiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.followTicket(payload);
  }

  @Action
  public reopenTicket(params: {
    id: number;
    payload: ReopenPusatResolusiV2Request;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.reopenIssue(params.id, params.payload);
  }
  @Action
  public finishTicket(params: {
    id: number;
    payload: FinishIssuePusatResolusiV2Request;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.finishIssue(params.id, params.payload);
  }
  @Action
  public getTicketDetail(id: number) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketDetail(id);
  }

  @Action
  public getTicketAction(params: {
    id: number;
    params: GetTicketActionRequest;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketAction(params.id, params.params);
  }

  @Action
  public submitNote(payload: SubmitNotePusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.submitNote(payload);
  }

  @Action
  public getTicketCounter(params: TicketCounterPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTicketCounter(params);
  }

  @Action
  public getListTicket(params: ListTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getListTicket(params);
  }

  @Action
  public create(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.create(params);
  }

  @Action
  public getMention(id: number) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getMentionData(id);
  }

  @Action
  public sendChat(params: {
    id: number;
    payload: SendChatPusatResolusiRequest;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.sendChat(params.id, params.payload);
  }

  @Action
  public getConversation(params: {
    id: number;
    params: GetConversationRequest;
  }) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getConversation(params.id, params.params);
  }

  @Action
  public getTemplate() {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.getTemplateChat();
  }

  @Action
  public async connectConversationWebsocket(id: number): Promise<WebSocket> {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.connectConversationWebsocket(id);
  }

  @Action
  public addTemplate(payload: AddTemplatePusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.addTemplate(payload);
  }

  @Action
  async requestDownloadLaporan(payload: DownloadLaporanRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.requestDownloadLaporan(payload);
  }
  bulkDownload = new BulkDownload();
  bulkDownloadConditions = new StateCondition({
    openWidgetDownload: false,
    loading: false
  });
  @Action
  async getBulkDownload(params: ApiRequestList) {
    try {
      this.bulkDownloadConditions.loading = true;
      const presenter = container.resolve(PusatResolusiV2Presenter);
      const res = await presenter.getBulkDownload(params);
      this.setBulkDownload(res);
      this.openWidgetDownload();
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Generate Laporan Gagal !", () =>
          this.getBulkDownload(params)
        )
      );
    } finally {
      this.bulkDownloadConditions.loading = false;
    }
  }
  @Mutation
  setBulkDownload(data: BulkDownload) {
    this.bulkDownload = data;
  }
  @Mutation
  openWidgetDownload() {
    this.bulkDownloadConditions.openWidgetDownload = true;
  }
  @Mutation
  closeWidgetDownload() {
    this.bulkDownloadConditions.openWidgetDownload = false;
  }

  @Action
  public checkTicketV2(params: CheckTicketPusatResolusiRequest) {
    const presenter = container.resolve(PusatResolusiV2Presenter);
    return presenter.checkTicketV2(params);
  }
}

export const PusatResolusiV2Controller = getModule(PusatResolusiV2Store);
